<template>
  <div class="modal">
    <div class="modal-viewport">
      <div class="modal-content">
        <expandable-items :title="'למה המערכת שלנו צריכה את הפרטים?'"
                          :title-color="'blue'"/>
        <div class="content">
          כדי לשלוח הודעות מעקב כמה פעמים בשבוע על התזרים, המערכת שלנו צריכה גישה לקריאת הנתונים מאתרי הבנק וכרטיסי האשראי,
          והדרך היחידה שהיא יכולה לעשות את זה היא באמצעות שם משתמש וסיסמא.
          <span class="important">המערכת שלנו משתמשת בנתונים לקריאה בלבד.</span>
          <br /><br />
          המידע נשמר בסטנדרט הגבוה ביותר של אבטחה בשרתי Amazon והתקשורת בין המערכות שלנו מוצפנת בפרוטוקול ההצפנה המאובטח ביותר.
          <span class="important">לעולם לא נעביר את המידע שלך לגורם חיצוני ללא אישור מפורש ממך.</span>
          <br /><br />
          אפשר לקרוא עוד על אבטחת מידע ופרטיות כאן:
          <br />
          <a href="https://www.riseup.co.il/trust" target="_blank" class="link">www.riseup.co.il/trust</a>
        </div>
      </div>
      <div class="click-area" v-on:click="closeModal('x-button')">
        <img class="modal-close" :src="require('@/assets/icons/modal-close-blue.svg')"/>
      </div>
    </div>
  </div>
</template>

<script>
import Segment from '../../../../../../Segment';
import ExpandableItems from '../../../../../../base-components/ExpandableItems.vue';

export default {
  name: 'TrustModal',
  components: {
    ExpandableItems,
  },
  created: () => {
    Segment.trackUserInteraction('TrustModalOpened');
    document.body.classList.add('modal-open');
  },
  props: {
    onModalClosed: Function,
  },
  methods: {
    closeModal(source) {
      Segment.trackUserInteraction('TrustModalClosed', { source });
      document.body.classList.remove('modal-open');
      this.onModalClosed();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .modal {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(43, 50, 59, 0.84);
    display: flex;
    justify-content: center;
    padding-top: 42px;
    text-align: right;
    z-index: 11;

    .modal-viewport {
      margin: 0 10px;
      position: relative;

      .click-area {
        height: 52px;
        width: 52px;
        position: absolute;
        left: -23px;
        top: -25px;
        cursor: pointer;

        .modal-close {
          display: block;
          margin: 10px auto auto;
        }
      }
    }

    .modal-content {
      background: $riseup_white;
      box-shadow: 0 2px 3px 0 rgba(155, 155, 155, 0.51);
      display: flex;
      flex-direction: column;
      height: max-content;
      max-height: 100%;
      overflow-y: auto;

      .expandable-items {
        padding-bottom: 0;
      }

      .content {
        display: inline-block;
        width: 280px;
        margin: 0 20px 20px 20px;
        padding: 18px 22px;
        line-height: 1.5;
        box-shadow: 0 2px 3px 0 rgba(155, 155, 155, 0.51);

        .important {
          font-weight: bold;
        }

        .link {
          font-weight: bold;
          text-decoration: underline;
          color: $riseup_light_blue;
        }
      }
    }
  }

</style>
